export const TRACKER_LOADER_URL = 'https://c.retailcrm.tech/widget/loader.js'

export function initializeTracker (settings) {
  if (
    typeof window === 'undefined' ||
    typeof document === 'undefined' ||
    settings?.active !== true ||
    typeof settings.token !== 'string' ||
    settings.token.trim() === '' ||
    trackerInitializationStarted()
  ) {
    return false
  }

  window._rcct = settings.token

  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = TRACKER_LOADER_URL
  document.head.appendChild(script)

  return true
}

function trackerInitializationStarted () {
  return Boolean(
    window.ocapi ||
    window._ocapi_init ||
    document.querySelector('script[src*="/widget/loader.js"]')
  )
}
